export default __webpack_public_path__ + "static/media/transito_marker.db016ca2.svg";